import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import SectionTitle from '../SectionTitle';

import { SuccessStoriesCarouselData } from './data';
import SuccessStoriesCarousel from './SuccessStoriesCarousel';

type Props = {
  isMobile?: boolean;
  isTablet?: boolean;
  title?: string;
  className?: string;
};

const SuccessStoriesSection = (
  {
    isMobile = false,
    isTablet = false,
    title = 'Success stories',
    className,
  }: Props,
  ref: React.Ref<HTMLDivElement>
) => {
  return (
    <Container ref={ref} className={className} $isMobile={isMobile}>
      <SectionTitle>{title}</SectionTitle>
      <SuccessStoriesCarousel
        isMobile={isMobile}
        isTablet={isTablet}
        slides={SuccessStoriesCarouselData}
      />
      <DashedLine $isMobile={isMobile} />
    </Container>
  );
};

export const DashedLine = styled.div<{ $isMobile: boolean }>`
  width: 1400px;
  display: block;
  margin: 78px auto 0;
  height: 1px;
  opacity: 0.2;
  border-top: 1px dashed ${({ theme }) => theme.colors.topicBlue};
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      width: 100vw;
      margin: 34px auto 0;
    `}

  ${({ theme }) => theme.breakpoints.down('lg')} {
    width: 900px;
  }
`;

const Container = styled.section<{ $isMobile: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 20;
  padding: 78px 0;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.white};
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      padding: 34px 0;
    `}
`;

export default forwardRef(SuccessStoriesSection);
